/**
 * Do not edit directly, this file was auto-generated.
 */

export const colorBlue50 = '#f0f8ff';
export const colorBlue100 = '#e0f0fe';
export const colorBlue200 = '#bbe3fc';
export const colorBlue300 = '#7eccfb';
export const colorBlue400 = '#3ab2f6';
export const colorBlue500 = '#1099e7';
export const colorBlue600 = '#0479c5';
export const colorBlue700 = '#0461a0';
export const colorBlue800 = '#085284';
export const colorBlue900 = '#0d456d';
export const colorBlue950 = '#0a3355';
export const colorTeal50 = '#f1fcfb';
export const colorTeal100 = '#cef9f3';
export const colorTeal200 = '#9df2e7';
export const colorTeal300 = '#4ce0d2';
export const colorTeal400 = '#34cdc4';
export const colorTeal500 = '#1bb1aa';
export const colorTeal600 = '#138e8b';
export const colorTeal700 = '#137270';
export const colorTeal800 = '#145b5a';
export const colorTeal900 = '#154c4b';
export const colorTeal950 = '#062c2d';
export const colorHighlighter50 = '#feffe5';
export const colorHighlighter100 = '#faffc7';
export const colorHighlighter200 = '#f3ff95';
export const colorHighlighter300 = '#eaff70';
export const colorHighlighter400 = '#d5f625';
export const colorHighlighter500 = '#b6dd05';
export const colorHighlighter600 = '#8eb100';
export const colorHighlighter700 = '#6a8605';
export const colorHighlighter800 = '#55690b';
export const colorHighlighter900 = '#46590e';
export const colorHighlighter950 = '#253201';
export const colorGrey50 = '#f7f7f7';
export const colorGrey100 = '#ededed';
export const colorGrey200 = '#dfdfdf';
export const colorGrey300 = '#c8c8c8';
export const colorGrey400 = '#b3b3b3';
export const colorGrey500 = '#999999';
export const colorGrey600 = '#888888';
export const colorGrey700 = '#7b7b7b';
export const colorGrey800 = '#676767';
export const colorGrey900 = '#545454';
export const colorGrey1000 = '#363636';
export const colorRed100 = '#fdeded';
export const colorRed400 = '#d00416';
export const colorRed900 = '#5F2120';
export const colorGreen100 = '#edf7ed';
export const colorGreen400 = '#1fc16b';
export const colorGreen900 = '#1e4620';
export const colorOrange100 = '#fff4e5';
export const colorOrange400 = '#ef6c00';
export const colorOrange900 = '#663c00';
export const colorPurple300 = '#b2b8ef';
export const colorPurple700 = '#6153b7';
export const colorPurple900 = '#403a75';
export const colorMagenta300 = '#faa7e7';
export const colorMagenta600 = '#ce2195';
export const colorMagenta900 = '#84175c';
export const colorWhite = '#fff';
export const colorBlack = '#000';
export const colorGreyPurple50 = '#f5f5f8';
export const colorGreyPurple100 = '#eceff3';
export const colorGreyPurple200 = '#dce1e9';
export const colorGreyPurple300 = '#c7cdda';
export const colorGreyPurple400 = '#b4bacd';
export const colorGreyPurple500 = '#9aa0ba';
export const colorGreyPurple600 = '#8487a7';
export const colorGreyPurple700 = '#717491';
export const colorGreyPurple800 = '#5d6076';
export const colorGreyPurple900 = '#4e5061';
export const colorGreyPurple950 = '#2e2f38';
export const colorGreyBlue50 = '#f4f8fa';
export const colorGreyBlue100 = '#e6edf3';
export const colorGreyBlue200 = '#d2dfeb';
export const colorGreyBlue300 = '#b3cbdd';
export const colorGreyBlue400 = '#8fb0cb';
export const colorGreyBlue500 = '#7497bd';
export const colorGreyBlue600 = '#6382af';
export const colorGreyBlue700 = '#56709f';
export const colorGreyBlue800 = '#4a5d83';
export const colorGreyBlue900 = '#3f4e69';
export const colorGreyBlue950 = '#2a3141';
export const colorPrimary = '#0a3355';
export const colorAction = '#3ab2f6';
export const colorDanger = '#d00416';
export const colorWarning = '#ef6c00';
export const colorSuccess = '#1fc16b';
export const colorProgramDropin = '#403a75';
export const colorProgramPickup = '#0461a0';
export const colorProgramLeague = '#6153b7';
export const colorProgramEvent = '#0d456d';
export const colorProgramClinic = '#0479c5';
export const colorProgramPractice = '#0479c5';
export const colorProgramRental = '#1099e7';
export const colorProgramTournament = '#062c2d';
export const colorProgramSeries = '#154c4b';
export const colorProgramClass = '#1bb1aa';
export const colorProgramVolunteerEvent = '#137270';
export const colorProgramVolunteerLeague = '#137270';
export const colorProgramPlayoffs = '#0479c5';
export const colorProgramVirtual = '#0479c5';
